/*
 * Copyright Mission 42 Ventures, Inc. All rights reserved.
 * Unauthorized copying, distribution, or use is prohibited.
 *
 * Standalone home for the Claude Usage panel, promoted out of the Control
 * Panel tab so it is findable from the sidebar by everyone with access. The
 * route and the sidebar item are both gated on ClaudeMetricsReadPermission
 * (per-person spend must not leak to the whole org); as everywhere else,
 * hiding the surface is UX -- the backend authorizes every read on its own.
 */

import React from 'react';
import { Content, Header, Page } from '@backstage/core-components';
import { ClaudeMetricsPanel } from './claudeMetricsPanel';

export const ClaudeUsagePage = () => (
  <Page themeId="tool">
    <Header
      title="Claude Usage"
      subtitle="Tokens and metered cost per run, reported by the CI workflows themselves"
    />
    <Content>
      <ClaudeMetricsPanel />
    </Content>
  </Page>
);
